import type { PrimeUiGuidanceArtifact } from "../types.js";

const EXPORT_MANIFEST_DESCRIPTION =
  "Local sidecar export manifest. This is the authoritative file-level contract for the selected transfer item. Files listed per page or exportable are functionality-critical dependencies for that item.";

const REFERENCE_EXPORT_DESCRIPTION =
  "Downloaded export project. Use this as the golden example for working behavior, file relationships, and integration details when the local result diverges or implementation is unclear.";

const CONFLICT_REPORT_DESCRIPTION =
  "Local diff report for files that were not copied because target files already differ. These conflicts represent required imported functionality and must be reviewed before the transfer is complete.";

export function buildExportManifestArtifact(
  manifestPath: string,
): PrimeUiGuidanceArtifact {
  return {
    kind: "export_manifest",
    path: manifestPath,
    description: EXPORT_MANIFEST_DESCRIPTION,
  };
}

export function buildReferenceExportArtifact(
  exportPath: string,
): PrimeUiGuidanceArtifact {
  return {
    kind: "reference_export",
    path: exportPath,
    description: REFERENCE_EXPORT_DESCRIPTION,
  };
}

export function buildConflictReportArtifact(
  reportPath: string,
): PrimeUiGuidanceArtifact {
  return {
    kind: "conflict_report",
    path: reportPath,
    description: CONFLICT_REPORT_DESCRIPTION,
  };
}
